import api from '@/core/api/client';

export interface FinancialPolicies {
  affiliatesEnabled?: boolean;
  billingMode: 'MANUAL';
  changeEffectiveAt: 'IMMEDIATE' | 'NEXT_RENEWAL';
  prorate: boolean;
  version: number;
  updatedAt: string | null;
  updatedByStaffUserId: string | null;
}
export interface FinancialPolicyInput {
  affiliatesEnabled?: boolean;
  billingMode: 'MANUAL'; changeEffectiveAt: FinancialPolicies['changeEffectiveAt']; prorate: boolean; expectedVersion: number;
}
export const financialPoliciesService = {
  async affiliateProgram(): Promise<{ enabled: boolean }> {
    const response = await api.get('/configuracoes/affiliate-program');
    if (!response.data.success) throw new Error('Não foi possível consultar o programa de afiliados.');
    return response.data.data;
  },
  async get(): Promise<FinancialPolicies> {
    const response = await api.get('/configuracoes/financial-policies');
    if (!response.data.success) throw new Error('Não foi possível carregar as políticas financeiras.');
    return response.data.data;
  },
  async save(input: FinancialPolicyInput): Promise<FinancialPolicies> {
    const response = await api.put('/configuracoes/financial-policies', input);
    if (!response.data.success) throw new Error('Não foi possível salvar as políticas financeiras.');
    return response.data.data;
  },
};
